import React from 'react';

const ImagePlusIcon = props => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth="2" strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M16 5h6"/>
            <path d="M19 2v6"/>
            <path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/>
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
            <circle cx="9" cy="9" r="2"/>
        </svg>
    );
};

export default ImagePlusIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ImagePlusIcon.jsx